import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { detectLang, useLocale } from "@/i18n/detect";
import { getRegisterUrl } from "@/lib/links";

const CTASection = () => {
  const { ui } = useLocale();
  const t = ui.cta;
  const registerUrl = getRegisterUrl(detectLang());
  return (
    <section className="py-24">
      <div className="container">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-cta px-8 py-16 text-center shadow-elegant md:px-16 md:py-24">
          <div className="absolute -top-32 left-1/2 h-80 w-80 -translate-x-1/2 rounded-full bg-primary/30 blur-3xl" />
          <div className="relative">
            <h2 className="mx-auto max-w-3xl font-display text-4xl font-extrabold leading-tight text-primary-foreground md:text-5xl">
              {t.title1}
              <br />
              <span className="bg-gradient-primary bg-clip-text text-transparent">{t.title2}</span>
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-lg text-primary-foreground/70">
              {t.subtitle}
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Button asChild variant="hero" size="xl" className="group">
                <a href={registerUrl} target="_blank" rel="noopener noreferrer">
                  {t.button}
                  <ArrowRight className="transition-transform group-hover:translate-x-1" />
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
